import type { HTMLAttributes } from "react";
import { cn } from "../lib/utils";

export function MaterialIcon({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      aria-hidden="true"
      className={cn("material-symbols-outlined", className)}
      {...props}
    >
      {children}
    </span>
  );
}
